import MenuItem from "03AdminPages/99Parts/MenuItem";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import { Divider, Drawer, IconButton, styled } from "@mui/material";

const MyToolBarIcon = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: "0 8px",
  ...theme.mixins.toolbar,
}));

const MyDrawer = styled(Drawer)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 5,
  position: "relative",
  whiteSpace: "nowrap",
  width: "50vw",
  flexShrink: 0,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    delay: 10,
  }),
}));

type Props = {
  open?: boolean;
  setOpen: any;
};

const SideBar = (props: Props) => {
  const handleDrawerClose = () => {
    props.setOpen(false);
  };

  if (props.open) {
    return (
      <MyDrawer
        variant="temporary"
        open={true}
        onClose={() => props.setOpen(false)}
      >
        <Divider />
        <MyToolBarIcon>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeft />
          </IconButton>
        </MyToolBarIcon>
        <MenuItem setOpen={props.setOpen} />
      </MyDrawer>
    );
  }

  return null;
};

export default SideBar;
